import clsx from "clsx";
import PropTypes from "prop-types";

import { Badge } from "@features/ui";

import { currencyFormat } from "@lib/text.helpers";

import "./amount-display.scss";

export const AmountDisplay = ({ value, label, className }) => {
  return (
    <div className={clsx("amount-display", className)}>
      <div className="amount-display-value">{currencyFormat(value)}</div>
      <Badge className="amount-display-label">{label}</Badge>
    </div>
  );
};

AmountDisplay.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};
